<template>
  <div>
    <NavbarMain />
    <div class="container-fluid">
      <!-- 404 Error Text -->
      <div class="text-center">
          <img src="@/assets/404.png" class="img-fluid" alt="..." />
        <p class="lead text-gray-800 mb-5">Página no encontrada</p>
        <a href="/">&larr; Regresar al sitio principal</a>
      </div>
    </div>
    <FooterComp />
  </div>
</template>

<script>
//import Dropdown from "primevue/dropdown";

//import InputText from "primevue/inputtext";
/*
import Dropdown from "primevue/dropdown";
import AutoComplete from "primevue/autocomplete";
import Calendar from "primevue/calendar";
import CascadeSelect from "primevue/cascadeselect";
*/

export default {
  data() {
    return {};
  },

  created: function() {},

  computed: {},

  methods: {},

  components: {

  },
};
</script>

<style></style>
